let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aqfZU")).then(() => parcelRequire('69xmC'));